import { render, staticRenderFns } from "./AppFile.vue?vue&type=template&id=71baeca4&"
import script from "./AppFile.vue?vue&type=script&lang=js&"
export * from "./AppFile.vue?vue&type=script&lang=js&"
import style0 from "./AppFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports